import React from 'react';
import {Stack} from '@mui/material';

const StackWithArrow = props=>{
    let {backgroundColor, arrowIndex, children, ...rest} = props;
    return <Stack sx={{
        backgroundColor,
        position: 'relative',
        '&::after': {
            content: '""',
            width: '100px',
            height: '100px',
            backgroundColor,
            position: 'absolute',
            transform: 'translate(-50%, 50%) rotate(45deg)',
            bottom: 0,
            left: '50%',
            zIndex: arrowIndex??-1,
        },
    }} {...rest}>
      {children}
    </Stack>;
};

export default StackWithArrow;
